query GET_LOTS_BY_OWNER_ID($ownerId: UUID) {
  lots (ownerId: $ownerId) {
    items {
      id
      name
      spots
      status
      longitude
      latitude
      floor
      maxHeightSupported
      hasSpaceForBiggerVehicles
      parkerInstructions
      description
      isApproved
      tags {
        id
        name
      }
      facility {
        id
        name
      }
      parkingSchedules {
        id
        name
        appliesToDays
        price
        priceHourly
        priceOvernight
        priority
        startDate
        endDate
        notes
        spots
        blackoutDates
        openingTime
        closingTime
        availableReservationTypes
      }
    }
  }
}
